import { createSelector } from 'reselect';
import { RootState } from '../../store';

const selectGraphRuleState =  (state: RootState) => state.graphRule;

export const selectGraphRule = createSelector(
    selectGraphRuleState,
    (graphRule) => graphRule,
);
